import { useState, useRef, useEffect } from "react";
const useContainerSize = () => {
  const [size, setSize] = useState({ height: 0, width: 0 });
  const containerRef = useRef(null);
  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;
    const handleResize = () => {
      if (element) {
        setSize({
          height: element.offsetHeight,
          width: element.offsetWidth
        });
      }
    };
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(element);
    handleResize();
    return () => {
      resizeObserver.disconnect();
    };
  }, [containerRef]);
  return [containerRef, size];
};
export {
  useContainerSize
};
